import type {
    ExcludeStatusFields,
    ExcludeAccountFields,
    HubspotMappingField,
} from "app/pages/sales-intelligence/common-components/export-table/types";
import type { CRMListObjectsType, IntegrationSyncStatus } from "../../types";
import type { FetchError } from "app/pages/sales-intelligence/types";
import { createAction, createAsyncAction } from "typesafe-actions";
import type { IntegrationStatusResponse } from "../../components/types";
import type { HubspotColumns } from "../type";

export const getHubspotStatusAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_STATUS_START",
    "@@si/management/hubspot-integration/GET_STATUS_SUCCESS",
    "@@si/management/hubspot-integration/GET_STATUS_FAILURE",
)<boolean, IntegrationStatusResponse, FetchError>();

export const getExcludeStatusFieldsAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_EXCLUDE_STATUS_FIELDS_START",
    "@@si/management/hubspot-integration/GET_EXCLUDE_STATUS_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/GET_EXCLUDE_STATUS_FIELDS_FAILURE",
)<void, ExcludeStatusFields, FetchError>();

export const getHsContactsFieldsAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_CONTACTS_FIELDS_START",
    "@@si/management/hubspot-integration/GET_CONTACTS_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/GET_CONTACTS_FIELDS_FAILURE",
)<void, string[], FetchError>();

export const getExcludeAccountFieldsAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_EXCLUDE_ACCOUNT_FIELDS_START",
    "@@si/management/hubspot-integration/GET_EXCLUDE_ACCOUNT_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/GET_EXCLUDE_ACCOUNT_FIELDS_FAILURE",
)<void, ExcludeAccountFields, FetchError>();

export const getMappingFieldsAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_MAPPING_FIELDS_START",
    "@@si/management/hubspot-integration/GET_MAPPING_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/GET_MAPPING_FIELDS_FAILURE",
)<void, HubspotMappingField[], FetchError>();

export const putStatusFieldAsync = createAsyncAction(
    "@@si/management/hubspot-integration/PUT_STATUS_FIELD_START",
    "@@si/management/hubspot-integration/PUT_STATUS_FIELD_SUCCESS",
    "@@si/management/hubspot-integration/PUT_STATUS_FIELD_FAILURE",
)<void, void, FetchError>();

export const putIntegrationLeadFilterStatusAsync = createAsyncAction(
    "@@si/management/hubspot-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_START",
    "@@si/management/hubspot-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const getIntegrationLeadFilterStatusAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_START",
    "@@si/management/hubspot-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const putFilterFieldsAsync = createAsyncAction(
    "@@si/management/hubspot-integration/PUT_FILTER_FIELDS_START",
    "@@si/management/hubspot-integration/PUT_FILTER_FIELDS_SUCCESS",
    "@@si/management/hubspot-integration/PUT_FILTER_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const disconnectHubspotAsync = createAsyncAction(
    "@@si/management/hubspot-integration/DISCONNECT_START",
    "@@si/management/hubspot-integration/DISCONNECT_SUCCESS",
    "@@si/management/hubspot-integration/DISCONNECT_FAILURE",
)<void, void, FetchError>();

export const setSyncStatus = createAction(
    "@@si/management/hubspot-integration/SET_STATUS_MANUALLY",
)<IntegrationSyncStatus>();

export const setIsHsCompaniesExportEnabled = createAction(
    "@@si/management/hubspot-integration/SET_IS_COMPANIES_EXPORT_ENABLED",
)<boolean>();

export const setIsHsContactsExportEnabled = createAction(
    "@@si/management/hubspot-integration/SET_IS_CONTACTS_EXPORT_ENABLED",
)<boolean>();

export const getHsColumnsAsync = createAsyncAction(
    "@@si/management/hubspot-integration/GET_COLUMNS_START",
    "@@si/management/hubspot-integration/GET_COLUMNS_SUCCESS",
    "@@si/management/hubspot-integration/GET_COLUMNS_FAILURE",
)<void, HubspotColumns, FetchError>();

export const setIsHsCrmLabelEnabled = createAction(
    "@@si/management/hubspot/manage-integration/SET_IS_CRM_LABEL_ENABLED",
)<boolean>();

export const setIsHsCrmListEnabled = createAction(
    "@@si/management/hubspot/manage-integration/SET_IS_CRM_LIST_ENABLED",
)<boolean>();

export const setHsCrmListObjectsType = createAction(
    "@@si/management/hubspot/manage-integrations/SET_HS_CRM_LIST_OBJECTS_TYPE",
)<CRMListObjectsType>();
